import { useState } from 'react'

import GymService from 'service/GymService'
import { ISaveGymSalonReservation } from 'types/GymType'
import AuthUtil from 'utils/AuthUtil'

export default function useSaveGymSalonReservation(resInfo: ISaveGymSalonReservation, closeAfterSave: () => void) {
  const [loading, setLoading] = useState(false)
  const employeeId = AuthUtil.getEmployeeSummary()?.id

  const saveGymSalonReservation = () => {
    setLoading(true)
    GymService.saveGymSalonReservation({
      ...resInfo,
      id: 0,
      employeeId: employeeId,
      isCancel: false,
    })
      .then((_res) => closeAfterSave())
      .catch((err) => console.log(err))
      .finally(() => setLoading(false))
  }

  return { saveGymSalonReservation, loading }
}
